import { useQuery } from "@tanstack/react-query";
import { GET_SECTIONS_FOR_SCHOOL } from "../api/queries";
import { graphQLClient } from "../graphqlClient";

export const fetchSections = async ({ queryKey }) => {
  const [, { parentID }] = queryKey;
  const { getSectionsForSchool } = await graphQLClient.request(
    GET_SECTIONS_FOR_SCHOOL,
    {
      parentID,
    },
  );
  return getSectionsForSchool;
};

export const useFetchSections = (assignedSite) => {
  return useQuery({
    queryKey: ["fetchSections", { parentID: assignedSite }],
    queryFn: fetchSections,
    enabled: !!assignedSite,
  });
};
